import axios from 'axios'
import { getBaseUrl } from '../../utils'

export const getSocialMedia = (lng: string) => {
  const baseUrl = getBaseUrl(lng)

  return axios.get(`${baseUrl}/api/v1/social_network_icons`).then((response) => response.data)
}
